import React, { useState , Suspense  } from 'react';
import { Layout, Spin,theme } from 'antd';
import NavbarHeader from 'components/websitelayout/NavbarHeader';
import FooterArea from 'components/websitelayout/FooterArea';
import SectionContent from '../website/homesections/SectionContent'; // Import the SectionContent component
import { Route, useLocation } from 'react-router-dom';
import Home from './Home'; 
import { SuspenseFallback } from 'components/SuspenseFallback';
const { Content } = Layout;
interface HomeLayoutProps {
    children: React.ReactNode;
    className?: string;
}
const Weblayout: React.FunctionComponent<HomeLayoutProps> = ({ children }) => {
    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();
    const [activeMenuItem, setActiveMenuItem] = useState(null);
    const location = useLocation();
    const handleMenuItemClick = (menuItemKey?: any) => {
        setActiveMenuItem(menuItemKey);
    };
    return (
        <Layout>
            <NavbarHeader activeMenuItem={activeMenuItem} handleMenuItemClick={handleMenuItemClick} />
            <Content>
            <Route exact path="/">
            <Suspense fallback={<SuspenseFallback/>}>
                <Home handleMenuItemClick={handleMenuItemClick}/>
            </Suspense>
            </Route>
                {location.pathname!= '/' && (
                    <Suspense fallback={<SuspenseFallback/>}>
                        {children}
                    </Suspense>
                )}
            </Content>
            <FooterArea activeMenuItem={activeMenuItem} handleMenuItemClick={handleMenuItemClick} />
        </Layout>
    );
};
export default React.memo(Weblayout);